import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import i18n from '../../i18n';
import TableBody from '@material-ui/core/TableBody';
import Icon from '@material-ui/core/Icon';
import React, {useState} from 'react';
import {withStyles} from '@material-ui/core';
import Query from 'react-apollo/Query';
import GraphQlLoading from '../GraphQl/Loading';
import GraphQlError from '../GraphQl/Error';
import {getMutationName} from '../Form/utils';
import Button from '@material-ui/core/Button';
import attachmentTypeMutations from '../../mutations/attachmentTypeMutations';
import attachmentQueries from '../../queries/attachmentQueries';
import AttachmentTypeEdit from './AttachmentTypeEdit';
import Tooltip from "@material-ui/core/Tooltip";
import ProjectStatusEdit from "../Project/ProjectStatusEdit";

const save = async (status) => {
    const mutation = status.id > 0 ? attachmentTypeMutations.updateAttachmentType : attachmentTypeMutations.createAttachmentType;
    const mutationName = getMutationName(mutation);
    if(!status.priority || status.priority === '') {
        status.priority = 0;
    }
    const {data: result} = await window.apolloClient.mutate({mutation, variables: {...status}});

    return result[mutationName];
};

const AttachmentTypesList = (props) => {
    let [adds, setAdds] = useState({data: []});
    const [typesList, setTypesList] = useState(props.types || []);
    const [restored, setRestored] = useState('');

    // add or remove type from current types list
    const changeTypesList = (option,action) => {
        if(action === 'remove') {
            setTypesList( typesList.filter(type => type !== option) );
        }
        if(action === 'restore') {
            if( !typesList.includes(option) ) {
                setTypesList([...typesList,option]);
                setRestored(option);
            }
        }
    };

    return (
        <React.Fragment>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col">{i18n.get('file.type_form.name')}</TableCell>
                        {/*<TableCell scope="col">{i18n.get('file.type_form.color')}</TableCell>*/}
                        {/*<TableCell scope="col">{i18n.get('file.type_form.priority')}</TableCell>*/}
                        <TableCell align={'center'}>
                            <Tooltip title={i18n.get('file.type_form.auto_select_info')}>
                                <span>{i18n.get('file.type_form.auto_select_by')}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell align={'center'}>{i18n.get('file.type_form.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Query
                        query={attachmentQueries.allAttachmentTypes}
                    >
                        {({loading, error, data}) => {
                            if (loading) {
                                return <TableRow><TableCell colSpan={5}><GraphQlLoading/></TableCell></TableRow>;
                            }
                            if (error) {
                                return <TableRow><TableCell colSpan={5}><GraphQlError/></TableCell></TableRow>;
                            }

                            return data.attachmenttypes.data && data.attachmenttypes.data.length > 0 &&
                                data.attachmenttypes.data.map((status, idx) => (
                                        <AttachmentTypeEdit
                                            key={`attachmentStatus_${idx}`}
                                            values={status}
                                            onChange={(status) => {
                                                save(status).then();
                                            }}
                                            typesList={typesList}
                                            changeTypesList={changeTypesList}
                                            setRestored={setRestored}
                                        />
                                    ),
                                );
                        }}
                    </Query>
                    {adds && adds.data && adds.data.length > 0 && adds.data.map((status, idx) => (
                        <AttachmentTypeEdit
                            key={`newAttachmentStatus_${idx}`}
                            values={status}
                            edit={true}
                            onChange={(status) => {
                                save(status);
                            }}
                            typesList={typesList}
                            changeTypesList={changeTypesList}
                            setRestored={setRestored}
                        />
                    ))}
                </TableBody>
            </Table>
            <Button
                variant="contained" size="small"
                onClick={() => {
                    adds.data.push({id: null, color: '', name: '', priority: '', auto_select_by: ''});
                    setAdds({data: adds.data});
                }}
                className={props.classes.spacing}
            >
                <Icon>add</Icon> {i18n.get('file.type_form.add')}
            </Button>
        </React.Fragment>
    );
};

const styles = theme => ({
    spacing: {
        marginTop: theme.spacing.unit * 2
    },
    span: {
        display: 'inline',
        margin: '0 5px',
    },
});

export default withStyles(styles)(AttachmentTypesList);
